const META_PIXEL_ID = '955795160795040'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code and fires init + PageView once.
 * Safe to call multiple times — it only initializes a single time.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  const f: any = window

  if (!f.fbq) {
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'

    // Append safely: prefer an existing <script>, otherwise fall back to
    // <head> or the document element. The original FB snippet assumes a
    // <script> tag already exists, which is not guaranteed in every
    // runtime (e.g. sandboxed preview iframes) and caused a crash.
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(t, firstScript)
    } else {
      ;(document.head || document.documentElement).appendChild(t)
    }
  }

  f.fbq('init', META_PIXEL_ID)
  f.fbq('track', 'PageView')
}
